<template>
  <div class="app-content">
    <Form ref="formValidate" :model="formValidate" :label-width="110">
      <Row>
        <Col :md="8" :sm="12" :xs="24">
          <FormItem label="订购时间:" prop="queryDate">
            <DatePicker type="datetimerange" v-model="queryDate" placeholder="订购时间" style="width: 500px"/>
          </FormItem>
        </Col>
        <Col :md="8" :sm="12" :xs="24">
          <FormItem label="手机号:" prop="phone">
            <Input v-model="formValidate.phone" placeholder="手机号" style="width: 100%;"/>
          </FormItem>
        </Col>
        <Col :md="8" :sm="12" :xs="24">
          <FormItem label="产品ID:" prop="mobile">
            <Input v-model="formValidate.offer_id" placeholder="产品ID" style="width: 100%;"/>
          </FormItem>
        </Col>
        <Col :md='24' class="text-right">
          <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
          <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
        </Col>
      </Row>
    </Form>
    <Row>
      <Col :md='24' style="margin-bottom: 20px">
        <Button
          type="info"
          icon="md-download"
          style="margin-right: 8px"
          :disabled="!queryData.length"
          @click="exportOrder"
        >导出
        </Button>
      </Col>
    </Row>
    <Table
      :columns="queryColumn"
      :loading="loading"
      :data="queryData"
      border
      ref="dataTable"
    >
      <template slot-scope="{row}" slot="status">
        <!--          <div>{{row.status === 0 ? '订购中' : (row.status === 1? '订购成功' : '订购失败')}}</div>-->
        <Tag color="blue" v-if="row.status === 0">订购中</Tag>
        <Tag color="cyan" v-else-if="row.status === 1">订购成功</Tag>
        <Tag color="red" v-else>订购失败</Tag>
      </template>
    </Table>
    <Row>
      <Col :md="24" class="pagination">
        <Page
          :total="totalPage"
          :page-size="pageSize"
          :current="pageNum"
          :disabled="loading"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          show-elevator show-sizer show-total/>
      </Col>
    </Row>

    <Modal
      v-model="showDetailsModel"
      title="权益下发详情"
      width="80%"
      @on-ok="showDetailsModel = false"
      @on-cancel="showDetailsModel = false">
      <management :is-com="true" ref="ManagementRef"></management>
    </Modal>
    <ExportFile ref="exportFile"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import api from '../../api'
import utils from '../../utils'
import RechargeStatus from '../../components/order/RechargeStatus'
import ExportFile from '../../components/common/ExportFile'
import Management from "@/views/order/Management.vue";

export default {
  components: {
    Management,
    RechargeStatus,
    ExportFile
  },
  data() {
    return {
      showDetailsModel: false,
      formValidate: {
        agentId: null,
        nodeState: null,
        offer_id: '',
        phone: null
      },
      queryDate: [],
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      stateList: [
        {
          value: 0,
          label: '订购中'
        },
        {
          value: 1,
          label: '订购成功'
        },
        {
          value: -1,
          label: '订购失败'
        },
        {
          value: 2,
          label: '已退订'
        }
      ]
    }
  },
  computed: {
    startDate() {
      return this.queryDate[0] ? this.queryDate[0].getTime() : null
    },
    endDate() {
      return this.queryDate[1] ? this.queryDate[1].getTime() : null
    },
    startDateText() {
      return this.startDate ? utils.formatDateTime(this.startDate) : null
    },
    endDateText() {
      return this.endDate ? utils.formatDateTime(this.endDate) : null
    },
    ...mapGetters('recharge', ['rechargeStatus']),
    queryColumn() {
      return [
        {
          title: '代理商名称',
          key: 'agent_name',
          width: 250
        },
        {
          title: '产品编号',
          key: 'offer_id',
          align: 'center',
          width: 110
        },
        {
          title: '关联商品',
          key: 'bind_good_name',
          align: 'center'
        },
        {
          title: '手机号',
          key: 'phone',
          width: 150,
          align: 'center'
        },
        {
          title: '权益下发次数',
          key: 'issue_count',
          width: 150,
          align: 'center'
        },
        {
          title: '最近一次权益下发时间',
          key: 'last_issue_time',
          align: 'center'
        },
        {
          title: '订购时间',
          key: 'product_issue_time',
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          width: 320,
          slot: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.openDetails(params.row)
                  }
                }
              }, '下发记录')
            ])
          }
        }
      ]
    }
  },
  methods: {
    openDetails(item) {
      this.showDetailsModel = true
      this.$refs.ManagementRef.getData1({account: item.phone, commodityId: item.bind_good_id})
    },
    formSubmit() {
      // 判断开始时间和结束时间
      if (this.startDate && this.endDate && (this.startDate >= this.endDate)) {
        this.$Message.error('开始时间不能大于或等于结束时间！')
        return
      } else if (this.startDate && !this.endDate) {
        this.$Message.error('请选择结束时间！')
        return
      } else if (!this.startDate && this.endDate) {
        this.$Message.error('请选择开始时间！')
        return
      }
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset() {
      this.$refs['formValidate'].resetFields()
      this.queryDate = []
      this.formSubmit()
    },
    getData() {
      this.loading = true
      let date = {
        start_date: this.startDate,
        end_date: this.endDate
      }
      api.order.productOrderDetails({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...date,
        ...this.formValidate
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出
    exportOrder() {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            if (item === 'startDate' || item === 'endDate') {
              params[item] = new Date(this.formValidate[item]).getTime()
            } else {
              params[item] = this.formValidate[item]
            }
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = 100
      this.$refs.exportFile.submit(api.order.productOrderDetailsOutExport, 'post', {
        ...params
      })
    }
  },
  created() {
    this.getData()
    api.agent.agentList({
      pageNum: 1,
      pageSize: 100
    })
      .then((res) => {
        this.agentList = res.data.records
          .map(item => ({
            value: item.id,
            label: item.agentName
          })) || []
      })
      .catch((err) => {
        this.$Message.error('获取代理商列表失败: ' + err.message)
      })
  }
}
</script>
